/**
 * Tabelas fiscais compartilhadas entre a aba NOTA FISCAL do produto e a
 * edição em massa do Módulo Fiscal. Um lugar só pra não divergirem.
 *
 * São os códigos oficiais mais usados em food service — não a tabela completa.
 * Quem decide a classificação é a contabilidade da loja.
 */

// Origem da mercadoria — tabela A do ICMS. Food service é quase sempre 0.
export const ORIGENS = [
  { v: "0", l: "0 — Nacional" },
  { v: "1", l: "1 — Estrangeira, importação direta" },
  { v: "2", l: "2 — Estrangeira, adquirida no mercado interno" },
  { v: "3", l: "3 — Nacional, conteúdo de importação > 40%" },
  { v: "4", l: "4 — Nacional, processos produtivos básicos" },
  { v: "5", l: "5 — Nacional, conteúdo de importação < 40%" },
  { v: "6", l: "6 — Estrangeira, importação direta, sem similar nacional" },
  { v: "7", l: "7 — Estrangeira, mercado interno, sem similar nacional" },
  { v: "8", l: "8 — Nacional, conteúdo de importação > 70%" },
];

// CFOP de saída mais usados no varejo/food service.
export const CFOPS = [
  { v: "5102", l: "5102 — Venda dentro do estado" },
  { v: "5405", l: "5405 — Venda dentro do estado, ST já recolhida" },
  { v: "5101", l: "5101 — Venda de produção própria, dentro do estado" },
  { v: "6102", l: "6102 — Venda para fora do estado" },
  { v: "5933", l: "5933 — Prestação de serviço tributada por ISS" },
];

// CSOSN — usado por loja no Simples Nacional.
export const CSOSNS = [
  { v: "102", l: "102 — Sem permissão de crédito" },
  { v: "103", l: "103 — Isenção do ICMS para faixa de receita" },
  { v: "300", l: "300 — Imune" },
  { v: "400", l: "400 — Não tributada pelo Simples" },
  { v: "500", l: "500 — ICMS cobrado por ST ou antecipação" },
  { v: "101", l: "101 — Com permissão de crédito" },
  { v: "900", l: "900 — Outros" },
];

// CST ICMS — usado por loja no regime normal.
export const CSTS_ICMS = [
  { v: "00", l: "00 — Tributada integralmente" },
  { v: "20", l: "20 — Com redução de base de cálculo" },
  { v: "40", l: "40 — Isenta" },
  { v: "41", l: "41 — Não tributada" },
  { v: "60", l: "60 — ICMS cobrado por ST" },
  { v: "90", l: "90 — Outras" },
];

export const CSTS_PIS_COFINS = [
  { v: "01", l: "01 — Tributável, alíquota básica" },
  { v: "04", l: "04 — Monofásica, alíquota zero" },
  { v: "06", l: "06 — Alíquota zero" },
  { v: "07", l: "07 — Isenta" },
  { v: "08", l: "08 — Sem incidência" },
  { v: "49", l: "49 — Outras operações de saída" },
];

export const UNIDADES = ["UN", "KG", "LT", "PC", "CX", "DZ", "ML", "G"];

// CST do IBS/CBS (Reforma Tributária, NT 2025.002).
export const CSTS_IBS_CBS = [
  { v: "000", l: "000 — Tributação integral" },
  { v: "200", l: "200 — Alíquota reduzida" },
  { v: "400", l: "400 — Isenção" },
  { v: "550", l: "550 — Suspensão" },
  { v: "620", l: "620 — Tributação monofásica" },
];

/**
 * Campos obrigatórios que faltam pro produto conseguir emitir NFC-e.
 * Lista vazia = pronto pra emitir.
 *
 * IBS/CBS ficam de fora de propósito: só viram obrigatórios pro Simples em
 * 04/01/2027, e travar por eles agora bloquearia loja que já poderia emitir.
 */
export function camposFaltando(fiscalConfig, regime = "simples") {
  const fc = fiscalConfig || {};
  const faltando = [];
  if (!fc.ncm || String(fc.ncm).length !== 8) faltando.push("NCM");
  if (!fc.cfop) faltando.push("CFOP");
  if (!fc.origem) faltando.push("Origem");
  if (regime === "simples" ? !fc.csosn : !fc.cst_icms) {
    faltando.push(regime === "simples" ? "CSOSN" : "CST do ICMS");
  }
  return faltando;
}

export function produtoPronto(fiscalConfig, regime = "simples") {
  return camposFaltando(fiscalConfig, regime).length === 0;
}

/** Normaliza o fiscal_config que vem da API (pode chegar como string JSON). */
export function parseFiscalConfig(bruto) {
  if (!bruto) return {};
  if (typeof bruto === "string") {
    try {
      return JSON.parse(bruto) || {};
    } catch {
      return {};
    }
  }
  return typeof bruto === "object" ? bruto : {};
}
